import React from "react";
import PropTypes from "prop-types";

const plainLeftClick = (event) =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey;

const INSIGHT_LINKS = [
  { key: "ai_insights", label: "AI Insights" },
  { key: "campaigns", label: "Top Campaigns" },
  { key: "subscribe_pages", label: "Subscribe Pages" },
  { key: "landing_pages", label: "Landing Pages" },
  { key: "referral_sources", label: "Referral Sources" },
  { key: "utms", label: "First-Touch UTMs" },
  { key: "custom_fields", label: "Custom Fields" },
];

const WebsiteInsightsToolbar = (props) => {
  return (
    <div className="CtasListToolbar WebsiteInsightsToolbar row hard-center">
      <div className="col-xs-12 website-insights-toolbar-inner">
        <div className="website-insights-toolbar-left">
          <h4 className="bold smooth website-insights-toolbar-title">
            <a
              style={{ color: "inherit" }}
              href={props.insightsUrl}
              onClick={(event) => {
                if (props.onSelectInsight && plainLeftClick(event)) {
                  event.preventDefault();
                  props.onSelectInsight("overview", event);
                }
              }}
            >
              Funnel Insights
            </a>
          </h4>
          <div className="website-insights-toolbar-links">
            {INSIGHT_LINKS.map((link) => {
              const isActive = props.selectedInsight === link.key;
              const href = props.insightUrls[link.key];

              return (
                <a
                  key={link.key}
                  href={href}
                  className="website-insights-toolbar-link"
                  onClick={(event) => {
                    if (props.onSelectInsight && plainLeftClick(event)) {
                      event.preventDefault();
                      props.onSelectInsight(link.key, event);
                    }
                  }}
                >
                  <button
                    type="button"
                    className={`btn website-insights-toolbar-link-btn bg-white text-black rounded-lg cursor-pointer border-none ${
                      isActive ? "!bg-slate-100" : ""
                    }`}
                    title={link.label}
                  >
                    {link.label}
                  </button>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

WebsiteInsightsToolbar.propTypes = {
  insightsUrl: PropTypes.string.isRequired,
  selectedInsight: PropTypes.string,
  onSelectInsight: PropTypes.func,
  insightUrls: PropTypes.shape({
    ai_insights: PropTypes.string.isRequired,
    campaigns: PropTypes.string.isRequired,
    subscribe_pages: PropTypes.string.isRequired,
    landing_pages: PropTypes.string.isRequired,
    referral_sources: PropTypes.string.isRequired,
    utms: PropTypes.string.isRequired,
    custom_fields: PropTypes.string.isRequired,
  }).isRequired,
};

export default WebsiteInsightsToolbar;
